import { Either, Option } from 'funfix-core';
import { List } from 'immutable';
import { foldPricingItem } from './PricingItem';
const validatePricingItems = pricingItems => {
  const sortedPricingItems = pricingItems.sort((a, b) => a.unitCount - b.unitCount);
  return Option.of(sortedPricingItems.find((pi, index, iter) => foldPricingItem(pi)(() => Option.of(index === 0 ? null : iter.get(index - 1)).filter(previous => foldPricingItem(previous)(() => false, () => true)).getOrElse(false), () => false))).map(() => Either.left('flatRate pricing items can only be the first pricing items')).getOrElseL(() => Either.right(sortedPricingItems));
};
const separateFlatRateAndPerUnitPricingItems = pricingItems => pricingItems.reduce((_ref, pi) => {
  let {
    flatRatePricingItems,
    perUnitPricingItems
  } = _ref;
  return foldPricingItem(pi)(frpi => ({
    flatRatePricingItems: flatRatePricingItems.push(frpi),
    perUnitPricingItems
  }), pupi => ({
    flatRatePricingItems,
    perUnitPricingItems: perUnitPricingItems.push(pupi)
  }));
}, {
  flatRatePricingItems: List(),
  perUnitPricingItems: List()
});
const calculatePerUnitPrice = (perUnitPricingItems, activeUsers) => {
  const {
    amount,
    usersRemaining,
    currencyCode
  } = perUnitPricingItems.reduce((calculationReduction, perUnitPricingItem) => {
    const numberOfUsersToChargeAtThisTier = Math.min(calculationReduction.usersRemaining, perUnitPricingItem.unitCount - calculationReduction.previousPricingItemUnitCount);
    return {
      amount: calculationReduction.amount + numberOfUsersToChargeAtThisTier * perUnitPricingItem.amount,
      usersRemaining: calculationReduction.usersRemaining - numberOfUsersToChargeAtThisTier,
      previousPricingItemUnitCount: perUnitPricingItem.unitCount,
      currencyCode: perUnitPricingItem.currencyCode // assuming all items in perUnitPricingItems belong to the same currency
    };
  }, {
    amount: 0,
    usersRemaining: activeUsers,
    previousPricingItemUnitCount: 0,
    currencyCode: ''
  });
  return usersRemaining === 0 ? Either.right({
    amount,
    currencyCode
  }) : Either.left('Available pricing items do not cover all users');
};
const maybeResolveFlatRatePrice = (flatRatePricingItems, activeUsers) => Option.of(flatRatePricingItems.find(frpi => activeUsers <= frpi.unitCount)).map(frpi => ({
  amount: frpi.amount,
  currencyCode: frpi.currencyCode
}));
const calculatePrice = (pricingItems, activeUsers) => validatePricingItems(pricingItems).map(separateFlatRateAndPerUnitPricingItems).flatMap(_ref2 => {
  let {
    flatRatePricingItems,
    perUnitPricingItems
  } = _ref2;
  return maybeResolveFlatRatePrice(flatRatePricingItems, activeUsers).map(Either.right).getOrElseL(() => calculatePerUnitPrice(perUnitPricingItems, activeUsers));
});
export default calculatePrice;